import { __assign, __rest } from "tslib";
import React from 'react';
import VeltReactionPinTooltipUserWireframe from './VeltReactionPinTooltipUserWireframe/VeltReactionPinTooltipUserWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltReactionPinTooltipUsersWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-users-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipUsersWireframe.User = VeltReactionPinTooltipUserWireframe;
export default VeltReactionPinTooltipUsersWireframe;
